// extracted by mini-css-extract-plugin
export default {"container":"VpsExpiredModal_container__M+aRX","header":"VpsExpiredModal_header__isNnd","row":"VpsExpiredModal_row__EwYtz","name":"VpsExpiredModal_name__jSH4u"};